module.exports = __webpack_public_path__ + "static/media/michael-dam-m-ez-3-po-f-gs-k-unsplash.e3f212cf.svg";